import React from "react";
import About from "../Client/About";
import Section from "../Client/Section";
import Counter from "../AboutUs/Counter";
import Features from "../Client/Features";
import Cta from "../Client/Cta";
import HowHiringProcessWorks from "../Client/HowHiringProcessWorks";
import CompanyTestimonal from "../Client/CompanyTestimonal";

const Client = () => {
    document.title = "Client - Matrix Executive Search Group";
    return (
        <React.Fragment>
            <Section />
            <About />
            <Counter />
            <Features />
            <CompanyTestimonal />
            <HowHiringProcessWorks />
            <Cta />
        </React.Fragment>
    );
};

export default Client;
